import { engineComponent, StringUtils, Utils } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { HtmlContainerElement } from "../Elements/HtmlContainerElement";
import { HtmlButtonElement } from "../Elements/HtmlButtonElement";
import { RouletteRacetrackConfiguration } from "../../CustomComponents/RouletteRacetrackConfiguration";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { HtmlRouletteTableElement } from "./HtmlRouletteTableElement";
import { BaseElement } from "../../Components/Elements/Graphics/BaseElement";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlRacetrackBetsElement extends HtmlRouletteTableElement {
    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor(
        parentId: string,
        id: string,
        className: string,
        racetrackElements: { [id: string]: SwitchElement },
        canvasElement: BaseElement,
        width: number,
        height: number,
    ) {
        super(parentId, id, className, canvasElement, width, height);

        this.createRacetrackBets(racetrackElements);
    }

    //******************************************************************************************************************
    //  CREATE
    //******************************************************************************************************************

    public setupInstanceHtmlElement(elem: BaseElement, width: number, height: number): void {
        super.setupInstanceHtmlElement(elem, width, height);
        this.instance.style.borderRadius = height * 0.5 + "px";
    }

    private createRacetrackBets(racetrackElements: { [id: string]: SwitchElement }): void {
        let w: number;
        let h: number;
        let showMagnifier: string;

        for (let key in racetrackElements) {
            switch (key) {
                case "R_26":
                case "R_5":
                case "R_8":
                case "R_10":
                case "R_23":
                    w = -1; // width will be set by css
                    h = -1; // height will be set by css
                    showMagnifier = "true";
                    break;
                case "R_tiers":
                    w = RouletteRacetrackConfiguration.TiersWidth;
                    h = RouletteRacetrackConfiguration.MiddleHeight;
                    showMagnifier = "false";
                    break;
                case "R_orphelins":
                    w = RouletteRacetrackConfiguration.OrphelinsWidth;
                    h = RouletteRacetrackConfiguration.MiddleHeight;
                    showMagnifier = "false";
                    break;
                case "R_voisins":
                    w = RouletteRacetrackConfiguration.VoisinsWidth;
                    h = RouletteRacetrackConfiguration.MiddleHeight;
                    showMagnifier = "false";
                    break;
                case "R_zeroGame":
                    w = RouletteRacetrackConfiguration.ZeroGameWidth;
                    h = RouletteRacetrackConfiguration.MiddleHeight;
                    showMagnifier = "false";
                    break;
                default:
                    w = RouletteRacetrackConfiguration.SingleWidth;
                    h = RouletteRacetrackConfiguration.SingleHeight;
                    showMagnifier = "true";
                    break;
            }

            this.generateHtmlRacetrackBet(this.instance, racetrackElements[key], key, w, h, showMagnifier);
        }
    }

    //******************************************************************************************************************
    //  HELPER
    //******************************************************************************************************************

    private generateHtmlRacetrackBet(
        holder: HTMLElement,
        racetrackElement: SwitchElement,
        actionId: string,
        width: number,
        height: number,
        showMagnifier: string = "false",
    ): void {
        let betType = actionId.split("_");
        let x: number = racetrackElement.position.x;
        let y: number = racetrackElement.position.y;

        let betHtmlPlace = this.createHtmlButton(actionId);
        this.setupHtmlElement(betHtmlPlace.instance, x, y, width, height);

        betHtmlPlace.instance.setAttribute("id", actionId);
        betHtmlPlace.instance.setAttribute("data-magnifier", showMagnifier);

        if (window["CHANNEL"] == "mobile") {
            const self = this;
            betHtmlPlace.instance.addEventListener("touchstart", (event: TouchEvent) => {
                self.onHtmlBetPlaceTouchStart(event, betType[0], betType[1], true);
            });

            betHtmlPlace.instance.addEventListener("touchmove", (event: TouchEvent) => {
                self.onHtmlBetPlaceTouchMove(event, true);
            });

            betHtmlPlace.instance.addEventListener("touchend", (event: TouchEvent) => {
                self.onHtmlBetPlaceTouchEnd(event, true);
            });
        } else {
            betHtmlPlace.instance.addEventListener(
                "mouseover",
                this.onHtmlBetPlaceMouseOver.bind(this, betType[0], betType[1], true),
            );
            betHtmlPlace.instance.addEventListener(
                "mouseout",
                this.onHtmlBetPlaceMouseOut.bind(this, betType[0], betType[1], true),
            );
        }

        holder.appendChild(betHtmlPlace.instance);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Custom/HtmlRacetrackBetsElement.ts
 **/